// if (window.location.pathname.includes("/product")) {
//   document.querySelectorAll("svg").forEach(svg => {
//     svg.style.pointerEvents = "none";
//   });
// }

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initB2BQuantity, 2000);
});

function initB2BQuantity() {
  const form = document.querySelector("[bss-b2b-main-product-form]");
  if (!form) return;

  const plusBtn = form.querySelector("[bss-b2b-btn-up-quantity]");
  const downBtn = form.querySelector("[bss-b2b-btn-down-quantity]");
  const quantity = form.querySelector(".outer-spin-button");

  const store = BSS_B2B?.storage?.variantStorage?.store;
  const firstVariant = store?.values()?.next()?.value;

  if (!firstVariant?.appliedQI) return;

  const { qty_increment_min, qty_increment } = firstVariant.appliedQI;

  quantity.setAttribute('min', qty_increment_min);
  quantity.setAttribute('step', qty_increment);
  quantity.setAttribute('value', qty_increment_min);

  plusBtn.setAttribute("@click.prevent", `plus(${qty_increment})`);
  downBtn.setAttribute("@click.prevent", `minus(${qty_increment})`);
}

const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
                initB2BQuantity() 
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 
